module.exports = __webpack_public_path__ + "img/kort-20.3fb11a34.jpg";